import React from "react";
import Modal from "react-bootstrap/Modal";

const ModalConfirmAlert = ({
  children,
  confirmAlertConfig,
  hideConfirmAlert,
  confirmAlert,
  cancelBtnTxt = "Cancel",
  confirmBtnTxt = "Confirm",
}) => {
  return (
    <>
      <Modal
        size={confirmAlertConfig.size}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={confirmAlertConfig.show}
        onHide={hideConfirmAlert}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{confirmAlertConfig.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-center">{children}</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-danger me-2"
            onClick={hideConfirmAlert}
          >
            {cancelBtnTxt}
          </button>
          <button
            type="button"
            className="btn btn-primary theme-violet"
            onClick={confirmAlert}
          >
            {confirmBtnTxt}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalConfirmAlert;
